export const useusersStore = defineStore('users', () => {
  const readUsers = useDirectusUsers()

  const user = ref()
  const users = ref([])
  const getUsers = computed(function () {
    return users
  })
  // ⚠️ Actuellement NON UTILISÉ : les seuls appels à getUsersData() dans l'app
  // sont commentés (distributors/subdistributor/create, distributors/accesses/create,
  // retailers/accesses/create). Conservé au cas où, mais avec des champs
  // explicites : la version précédente ('*' + 'distributor.owner.*' sur 4200+
  // users) correspond au profil de requête qui provoque des 503 côté Directus.
  async function getUsersData() {
    // Directus plafonne limit=-1 à 1000 → paginer pour tout récupérer (4000+ users).
    const data = await paginateAll((page, limit) =>
      readUsers.getUsers({
        params: {
          fields: [
            'id', 'first_name', 'last_name', 'email', 'status',
            'dentsu_distributors_accesses.level',
            'dentsu_distributors_accesses.distributor.title',
            'dentsu_distributors_accesses.distributor.owner.first_name',
            'dentsu_distributors_accesses.distributor.owner.last_name',
          ],
          sort: ['last_name'],
          page,
          limit,
        },
      })
    )
    users.value = data
    return users
  }

  return { users, getUsers, getUsersData, user }
})